import {
  TrackerProviders,
  TrackerRoot,
  TrackerStandalone,
} from '@firstdelivery/tracker-ui'
import PageMetadata from './components/PageMetadata'
import { trackerAppEnv } from './env'
import { parseTrackerRoute } from './routes'

const HOME_METADATA = {
  title: 'Delivery Tracker',
  description: 'Delivery Tracker',
}

const ORDER_METADATA = {
  title: 'Delivery Tracker - Order',
  description: 'First Order Tracker',
}

function App() {
  const route = parseTrackerRoute(
    window.location.pathname,
    trackerAppEnv.basePath,
    window.location.search
  )

  if (route.kind === 'order') {
    return (
      <>
        <PageMetadata
          title={ORDER_METADATA.title}
          description={ORDER_METADATA.description}
        />
        <TrackerStandalone
          orderId={route.orderId}
          apiBaseUrl={trackerAppEnv.apiBaseUrl}
          mapboxAccessToken={trackerAppEnv.mapboxAccessToken}
        />
      </>
    )
  }

  return (
    <>
      <PageMetadata
        title={HOME_METADATA.title}
        description={HOME_METADATA.description}
      />
      <TrackerProviders mapboxAccessToken={trackerAppEnv.mapboxAccessToken}>
        <TrackerRoot />
      </TrackerProviders>
    </>
  )
}

export default App
